import { useState, useCallback } from "react";
import { dilapidationService } from "@/api/services/dilapidation.service";
export function useDilapidationFeedback(jobId, onSuccess) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const submitFeedback = useCallback(async (isApprove, feedback, changeStatus = false) => {
        if (!jobId)
            return null;
        setLoading(true);
        setError(null);
        try {
            const response = await dilapidationService.updateFeedback(jobId, {
                isApprove,
                feedback,
                changeStatus,
            });
            const dilapidation = response.data?.dilapidation ?? null;
            if (dilapidation) {
                onSuccess?.(dilapidation);
            }
            return dilapidation;
        }
        catch (err) {
            const errorMessage = err instanceof Error ? err.message : "Failed to submit feedback";
            setError(errorMessage);
            return null;
        }
        finally {
            setLoading(false);
        }
    }, [jobId, onSuccess]);
    return { submitFeedback, loading, error };
}
